import { wait } from '../utils';
import { ConfirmTransactionError } from './errors';
/**
 * Can be used as fallback when websocket died (in connection.confirmTransaction) or RPC doen't support websockets at all
 * Throws ConfirmTransactionError if something goes wrong
 */
export async function confirmTransactionByPollingSignatureStatus({ signature, connection, abortSignal, refetchInterval, }) {
    try {
        while (!abortSignal.aborted) {
            await wait(refetchInterval * 1000);
            const { value: signatureValues } = await connection.getSignatureStatuses([signature], {
                searchTransactionHistory: false,
            });
            if (signatureValues?.[0]?.confirmationStatus === 'confirmed') {
                return signature;
            }
        }
    }
    catch (error) {
        throw new ConfirmTransactionError('ConfirmTransactionError');
    }
}
